import { AppDispatch } from "redux/store";
import { SET_FORM_MODAL_ERROR, SET_FORM_MODAL_OPEN } from "./constants";
import { formService } from "api"
import { sendFormToLocalStorage } from "utils/LocalStorageHelper";
import {useAppSelector} from "../hooks";

export const setFormModalOpen = (data: boolean) => ({
    type: SET_FORM_MODAL_OPEN,
    payload: data
})

interface IFormDataHandlerArgs<T> {
    data: Record<keyof T, T[keyof T]>,
    localStorageName?: string 
}

interface IGeneralFromData<T> {
    data: Record<keyof T, T[keyof T]>
}

export const sendFormDataHandler = <T extends IFormDataHandlerArgs<T>>(data: T) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setFormModalOpen(true));

        const res = await formService.sendFormData(data.data, "callback");

        if (res.status > 300) {
            throw new Error("Ошибка при запросе на сервер status: " + res.status)
        }

        if (data.localStorageName && JSON.parse(localStorage.getItem(data.localStorageName) || "") && res.status < 300) {
            localStorage.removeItem(data.localStorageName)
        }

    } catch (error: any) {
        sendFormToLocalStorage(data)
        console.error(error.message)
    }
}

export const sendGeneralFromData = <T extends IGeneralFromData<T>>(data: T, callbackId: string) => async (dispatch: AppDispatch) => {
    try {
        const res = await formService.sendFormData(data.data, callbackId);

        if(res.status > 300) {
            throw new Error("Ошибка при запросе на сервер status: " + res.status);
        }

    } catch (error: any) {
        console.error(error.message);
        dispatch(setFormModalError(error.message));
    } finally {
        dispatch(setFormModalOpen(true));
    }
}

export const setFormModalError = (data: string | null) => ({
    type: SET_FORM_MODAL_ERROR,
    payload: data
})